module.exports = __webpack_public_path__ + "img/game-pic.c94013b1.svg";